import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./ArticleTitle.module.css";


type SArticleTitleProps = {
    children: ReactNode;
    className?: string;
};

export default function SArticleTitle({ children, className }: SArticleTitleProps) {
    return <h1 className={classNames(styles.ArticleTitle, className)}>{children}</h1>
}
